export const getPriceWithTax = (price: number) => {
  if (!price || price === 0) {
    return 0;
  }
  const tax = (price * 20) / 100;
  return price + tax;
};

export const checkLimitFileSize = (file: File) => {
  if (file.size > 5000000) {
    return false;
  }
  return true;
};

export const formatId = (stringId: string) => {
  if (!stringId) {
    return '';
  }
  const split = `${stringId}`.split('/');
  return split[split.length - 1];
};

export const unFormatId = (id: number, typeName: string) => {
  return `/v1/${typeName}/${id}`;
};

export const toString = (value?: any | null) => (value ? value.toString() : '');
